import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "./config.service";

@Injectable({
  providedIn: "root",
})
export class ShiftService {
  readonly URL_API = this.config.getConfig().url + "/turnos";
  constructor(private http: HttpClient, private config: ConfigService) { }

  public getWithType(type: string, page: number = 1, container: string = "") {
    if (container) {
      return this.http.get(`${this.URL_API}/tipo/${type}`, {
        params: {
          page: page.toString(),
          container: container,
        },
      });
    } else {
      return this.http.get(`${this.URL_API}/tipo/${type}`, {
        params: {
          page: page.toString(),
        },
      });
    }
  }

  public get() {
    return this.http.get(`${this.URL_API}/`);
  }

  public getCloseDays() {
    return this.http.get(`${this.URL_API}/closeDay`);
  }

  public getTodayCloseDays() {
    return this.http.get(`${this.URL_API}/closeDay/today`);
  }

  public getShift(id: String) {
    return this.http.get(`${this.URL_API}/${id}`);
  }

  public cancel(shift: any, id: string) {
    return this.http.delete(`${this.URL_API}/${id}?obvs=${shift.obvs}`);
  }

  public getMoney() {
    return this.http.get(`${this.URL_API}/money`);
  }

  public post(shift: any) {
    return this.http.post(`${this.URL_API}/`, shift);
  }

  public postSimple(shift: any) {
    return this.http.post(`${this.URL_API}/simple`, shift);
  }

  public postLibre(shift: any) {
    return this.http.post(`${this.URL_API}/libre`, shift);
  }

  public postExport(shift: any) {
    return this.http.post(`${this.URL_API}/export`, shift);
  }

  public postMoney(moeny: any) {
    return this.http.post(`${this.URL_API}/money`, moeny);
  }

  public postCloseDay() {
    return this.http.post(`${this.URL_API}/closeDay`, {});
  }

  public putCloseDay(id: string) {
    return this.http.put(`${this.URL_API}/closeDay/${id}`, {});
  }

  public postReShifted(id: string, shift: any) {
    return this.http.put(`${this.URL_API}/${id}`, shift);
  }

  public getFilter(filter) {
    return this.http.post(`${this.URL_API}/getFilter`, filter);
  }

  public sendFile(pdf: string, fileName) {
    return this.http.post(`${this.URL_API}/file`, {
      pdf: pdf,
      fileName: fileName,
    });
  }
}
